module.exports = __webpack_public_path__ + "img/img001.70181a10.png";